import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../MyComponents/Footer";
import GuestNav from "../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../MyComponents/Hero2";
import heroContent from "./HeroContent";
import "./CodingPortal.css";
import CourseExplorer from "../../MyComponents/CourseExplorer";
import leftimg from "../../assets/Codingleftimg.png";
import rightimg from "../../assets/Codingrightimg.png";
import scratchimg from "../../assets/Scratchimg.png";
import appimg from "../../assets/Appimg.png";
import webimg from "../../assets/Webimg.png";
import pythonimg from "../../assets/pythonimg.png";
import cppimg from "../../assets/C++img.png";
import unityimg from "../../assets/Unitygameimg.png";
import machineimg from "../../assets/Machineimg.png";
import databaseimg from "../../assets/Databaseimg.png";
import androidimg from "../../assets/Androidimg.png";
import AIimg from "../../assets/AIpromptimg.png";
import phpimg from "../../assets/PHPimg.png";
import gameimg from "../../assets/Gameimg.png";
import datascienceimg from "../../assets/AIimg.png";
import CourseSection from "../../MyComponents/CourseSection";
import LearningStyle from "../../MyComponents/LearningStyle";
import Testimonials from "../../MyComponents/Testimonials";
import FAQs from "../../MyComponents/FooterPages/newfaq";

// Course data
const courses = [
  { title: "Scratch Programming", image: scratchimg },
  { title: "App Development", image: appimg },
  { title: "Web Development", image: webimg },
  { title: "Game Development", image: gameimg },
  { title: "PHP Procedural Programming", image: phpimg },
  { title: "AI and data Science", image: datascienceimg },
  { title: "Python Programming", image: pythonimg },
  { title: "C++ Programming", image: cppimg, path: "/cpp-programming" },
  { title: "Unity Game Development", image: unityimg, path: "/unity-game-dev" },
  { title: "Machine Learning", image: machineimg, path: "/machine-learning" },
  { title: "Database Management", image: databaseimg },
  {
    title: "Android App Development",
    image: androidimg,
    path: "/android-app-dev",
  },
  {
    title: "AI Prompt Engineering",
    image: AIimg,
    path: "/ai-prompt-engineering",
  },
];

const CodingPortal = () => {
  const [activeGrade, setActiveGrade] = useState("9-12");

  const handleGradeChange = (grade) => {
    setActiveGrade(grade);
  };

  const codingpage = heroContent.codingpage;

  // Scroll to the top when the component is mounted
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <GuestNav />
      <Hero2
        titlePart1={codingpage.titlePart1}
        titlePart2={codingpage.titlePart2}
        description={codingpage.description}
        buttonText={codingpage.buttonText}
        leftImage={leftimg}
        rightImage={rightimg}
      />
      <CourseExplorer
        title="Explore Our Fun & Skill-Boosting Coding Courses"
        highlightText="Coding Courses"
        courses={courses}
      />

      <CourseSection />
      <LearningStyle />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};

export default CodingPortal;
